$(document).ready(function(){
    function updateSubmenuHeight(element) {
        var h = $(element).parents('.menu_wrapper').innerHeight() || 400;
        console.log(h);
        document.documentElement.style.setProperty('--submenu-height', h + 'px');
        $('.mega-menu-horizontal__inner').css("--submenu-height",h +"px");
    }

    $(".nav_main_wrap .first-child").hover(
      function () {
        $(this).addClass('active');  
        // updateSubmenuHeight(this);
        $('.mega-menu-horizontal__promo.slick-slider').slick('refresh');
      },
      function () {
        $(this).removeClass('active');  
        // document.documentElement.style.setProperty('--submenu-height', '0px');
        // $('.mega-menu-horizontal__inner').css("--submenu-height",400 +"px");
        $('.mega-menu-horizontal__promo.slick-slider').slick('refresh');
      }
    );
});
// accordian
  if ($(window).width() < 767) {
      $('body').on('click', '.footer-block--links p.footer-block__heading', function() {
          if($(this).parent().hasClass('active')){
              $(this).parent().removeClass('active');
              $(this).next().slideUp();
          }else{
              $('.footer-block--links p.footer-block__heading.active').next().slideUp();
              $('.footer-block--links p.footer-block__heading.active').removeClass('active');
              $(this).parent().addClass('active');
              $(this).next().slideDown();
          }
      });
  }
// get height header and announcement-bar 

    var announcement = $('.section-announcement-bar:visible').length ? $('.section-announcement-bar').innerHeight() : 0;
    var headerHeight = $('.section-site-header:visible').length ? $('.section-site-header').innerHeight() : 0;
    var total = announcement + headerHeight;

    if (!isNaN(total) && total > 0) {
        document.documentElement.style.setProperty('--header_height', total + 'px');
        console.log('--header_height:', total + 'px');
    }

//modal card js
$('body').off('click', '.card-swatches-main').on('click', '.card-swatches-main', function () {
  var variant_id = $(this).find('input').attr('data-variant-id');
  console.log("Selected Variant ID:", variant_id);

  $(this)
    .closest('.product-card__info')
    .find('.modal-buy-buttons input[name="id"]')
    .val(variant_id);

  var url = $(this)
    .closest('.product-card__info')
    .find('.product-name a')
    .attr('href');

  if (!url) {
    console.error("Product URL not found");
    return;
  }

  url = url.split('?')[0];

  produpdate(url, variant_id, $(this));
});


function produpdate(baseUrl, variant_id, el) {
  var updatedUrl = `${baseUrl}?variant=${variant_id}`;
  console.log("Fetching:", updatedUrl);
  $.ajax({
    url: updatedUrl,
    type: 'GET',
    success: function (data) {
      var $tempDiv = $('<div>').html(data);

      var shippingText = $tempDiv.find('.product-info__shipping-text').html();
      var btn_add = $tempDiv.find('product-form .btn-add-cart span').html();
      console.log(btn_add);
      el.closest('.product-card__info')
          .find('product-form .button-add-to-cart span').html(btn_add);
              el.closest('.product-card__info')
          .find('.product-info__shipping-card')
          .html('');
      if (shippingText) {
        el.closest('.product-card__info')
          .find('.product-info__shipping-card')
          .html(shippingText);
      } else {
        el.closest('.product-card__info')
          .find('.product-info__shipping-card')
          .html('');
      }
    },
    error: function (xhr, status, error) {
      console.error("Failed to fetch the page:", error);
    }
  });
}




// search
$(document).ready(function() {
  if ($(window).width() > 1199) {
    document.querySelector('search-modal')?.setAttribute('position', 'right');
  }
});
$('body').on('click', 'quick-add-modal .product-quick-add-modal', function() {
    var currentProductUrl = $('quick-add-modal .quick-add-modal-content a.product-title').attr("href");
  console.log(currentProductUrl);
  
    $(".product-card").each(function() {
        var loopUrl = $(this).find('.product-name a').attr("href");
        if(loopUrl == currentProductUrl){
            $(this).closest('.section-featured-collection').find('.modal-open').click();
            $(this).closest('.collection-grid').find('.modal-open').click();
          $('body').addClass('overflow-hidden');
        }
    });
});


// Add to cart listener.
// document.addEventListener('product:added-to-cart', (e) => { 
//     console.log(e, 'eeee'); 
//     addCart();
// });

// Cart change listener.
// document.addEventListener('change', (e) => { 
//     console.log(e, 'eeeessssss'); 
//     addCart();
// });

let debounceTimer;

document.addEventListener('cart:reload', (e) => {
  clearTimeout(debounceTimer);
  debounceTimer = setTimeout(() => {
    // Only runs after user stops triggering events for 300ms
    console.log(e, 'cart:reload');
    addCart();
  }, 800);
});

let carRefreshDebounce;

function cartRefresh(){
    clearTimeout(carRefreshDebounce);
    carRefreshDebounce = setTimeout(() => {
    console.log('cart:refresh 42185304277015 41789183361047 ');
    if (window.location.pathname === '/cart') {
      window.location.reload();
    } else {
       document.dispatchEvent(new CustomEvent("product:added-to-cart",{
            detail: {
                quantity: 1
            }
        }))
    }
  }, 300);

}

function addCart() {
  let data;
  var v_id = $('.cust-shipping-wrap').attr('data_id');
  if ($('.shipping-wrap').hasClass("free-gift-added") && !$('.shipping-wrap.free-gift-added').hasClass("have_product")) {
    data = {
      id: v_id,
      quantity: 1
    };
  } else if ($('.shipping-wrap').hasClass("free-gift-not-added")) {
    data = {
      id: v_id,
      quantity: 0
    };
  }

  console.log('addCArt', data);

  if (data && data.quantity == 1) {
    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: data,
      dataType: 'json',
      success: function(response) {
        console.log('done', response);
        // Optional: dispatch a custom event if needed
        cartRefresh();
      },
      error: function(xhr, status, error) {
        console.log('error', error);
      }
    });
  } else {
    let key =  $('.shipping-wrap.free-gift-not-added').attr('data-key');
    if($('.shipping-wrap').hasClass("free-gift-not-added") && key){
      console.log('Nothing to update in cart');
      
      
      $.ajax({
        type: 'POST',
        url: '/cart/change.js',
        data: {
          "id": key,
          "quantity": 0
        },
        dataType: 'json',
        success: function(response) {
          console.log('done', response);
          // Optional: dispatch a custom event if needed
          cartRefresh();
        },
        error: function(xhr, status, error) {
          console.log('error', error);
        }
      });
    }
    
  }
}

// Upsell product
let debounceTimerCust;

window.cartJustReloaded = false;

// Attach cart:reload listener only once
if (!window.cartReloadListenerAttached) {
  document.addEventListener('cart:reload', (e) => {
    clearTimeout(debounceTimerCust);
    debounceTimerCust = setTimeout(() => {
      console.log(e, 'cart:reload');
      window.cartJustReloaded = true;
      // addCart_upsell(); // Assuming this is your function to refresh upsells
    }, 800);
  });

  window.cartReloadListenerAttached = true;
}
var $btn ;
// Click handler for upsell buttons
$('body').on('click', '.upsell-btn', function () {
   $btn = $(this);
  var $form = $(this).closest('form');
  var upsellVariantId = $form.find('input[name="id"]').val();
  var mainVariantId = $('.modal-open').closest('form').find('input[name="id"]').val();

  if (!upsellVariantId || !mainVariantId) {
    console.warn('Missing variant IDs');
    return;
  }

  if (!window.cartJustReloaded) {
    console.log('Upsell blocked: cart:reload not triggered yet');
    return;
  }
  $btn.prop('disabled', true)
    .attr('aria-loading', 'true')
    .addClass('pointer-events-none')
    .css('color', 'transparent')
    .data('original-html', $btn.html()) // Save original content to restore later
    .html(`
      <span style="opacity: 0;">${$btn.text().trim()}</span>
      <svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    `);

  console.log('Upsell confirmed. Proceeding...');
  window.cartJustReloaded = false; 
  removeMainAndAddUpsell(mainVariantId, upsellVariantId);
});

// Remove main item and add upsell
function removeMainAndAddUpsell(mainVariantId, upsellVariantId) {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const lineItem = cart.items.find(item => item.variant_id == mainVariantId);

      if (!lineItem) {
        console.warn('Main product not found in cart. Skipping removal.');
        return addUpsellOnly(upsellVariantId);
      }

      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: lineItem.key,
          quantity: 0,
        }),
      })
        .then(res => res.json())
        .then(() => {
          console.log('Main product removed');
          addUpsellOnly(upsellVariantId);
        });
    })
    .catch(err => {
      console.error('Error in removeMainAndAddUpsell:', err);
    });
}

// Add only the upsell product and trigger cart:reload
function addUpsellOnly(variantId) {
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: variantId,
      quantity: 1,
    }),
  })
    .then(res => res.json())
    .then(data => {
      console.log('Upsell product added:', data);
      cartRefresh();
      $('#product-upsell-modal').removeClass('active');
      $('body').removeClass('overflow-hidden');
      // Dispatch event to re-trigger any upsell logic
      const event = new CustomEvent('cart:reload', {
        detail: { variantId },
      });
      document.dispatchEvent(event);
      $btn.html($btn.data('original-html'))
      .removeAttr('aria-loading')
      .removeClass('pointer-events-none')
      .css('color', '')
      .prop('disabled', false);
      addCart();
    })
    .catch(err => {
      console.error('Error adding upsell product:', err);
    });
}




